export const confirmPasswordError = "Confirm password does not match";
export const newPasswordError = "Invalid password";
